export const formatResetTime = (resetAt) => {
    if (!resetAt) return '';
    try {
        const resetDate = new Date(resetAt);
        const now = new Date();
        const diffMs = resetDate - now;
        const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
        const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

        if (diffHours > 0) {
            return `Resets in ${diffHours}h ${diffMins}m`;
        } else if (diffMins > 0) {
            return `Resets in ${diffMins}m`;
        }
        return 'Resets soon';
    } catch (e) {
        return '';
    }
};
